import React from 'react';
import "../../styles/campus-syllabus/main.css";

const Main = () => {
    return (
        <div id='CampusSyllabus'>
            <div className="campus-syllabus">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="new-things">
                        <div className="row-new">
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Biotechnology
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc. Biotechnology NEP 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/msc-biotechnology-nep-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Biotechnology </td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/04/syl(M.Sc.%20Biotechnology).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Biotechnology(Hons.) </td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/04/DBT-%20B.Sc.%20Biotech.%20Hons.%20Syllabus.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. biotechnology(CBCS)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/04/m.sc.(biotechnology%20CBCS).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Institute of Business Studies
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>MBA (Hospital Administration) 2025-27</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/mba-hosp-administration.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>BBA (Honours & Honours with Research) 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/bba-hons-research_compressed.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.B.A.</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/111syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.B.A. (2013-14)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/503syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.B.A. (2017-18)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/504syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>MBA (Hospital Administration):2 years Program</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/113syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.B.A. (w.e.f. 2020-21)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/114syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        MBA (Hospital Administration):5 years Integrated Program
                                                    </td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/500syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.B.A. (Hospital Administration)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/502syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.B.A. 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/mba_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.B.A. Ordinance 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/ordinances_mba_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Botany
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc. Botany (Choice Based Credit System)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/public/pdf/2024/01/syllabus-msc(botany)_30-01-2024_1706610308.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        M.Sc. (Botany); CBCS (NEP-2020 w.e.f. the session 2023-2024)
                                                    </td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/public/pdf/2024/01/syllabus-msc(botany)_30-01-2024_1706610308.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Pre Ph.D. (Botany) (NEP-2020 w.e.f. the session 2022-2023)
                                                    </td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/420syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Under NEP</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/446syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Coursework (Botany)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/607syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Honours 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/b.sc_hons_botany_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Chemistry
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc. Chemistry New Syllabus (BOS 2022)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/582syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Chemistry (Spl. in PSCT) new syllabus 2022-23</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/583syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Under NEP</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Chemistry-NEP-Syllabus-n.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc (H) Chemistry new syllabus (2022-23)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/581syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc.Biochemistry new syllabus2022 (1)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/585syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. (H) Chemistry old syllabus</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/578syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc.Biochemistry Old Syllabus</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/579syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Chemistry (Spl. in PSCT) old syllabus 2019-20 (1)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/580syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M. Sc. Chemistry syllabus old</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/586syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Coursework (Chemistry)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/612syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Value Added Course Chemistry 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/value_added_courses_chemistry_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>MGEC Pool 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/MGEC_pool_2024-25_chemistry.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Honours (Value Added Course) 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/VAC_course_b.sc_hons_chemistry_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Honours &amp; Honours with Research 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/b.sc._chemistry_hons_hons_with_research_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Commerce
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>B.Com. (Honors)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/160syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Com.</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/161syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Com.(2022-23)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/460syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Com (CBCS)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/491syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-PhD. Course Work</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/598syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Minor Papers for U.G Students (NEP)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/610syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Com Commerce 2022-23</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_m.com_commerce_2022-23.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Com. (Honours and Honours with Research) 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/b.com_hons_and_hons_with_research_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Com 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/m.com_2024-2025.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Computer Application
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>MCA (Master in Computer Application)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/16syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>MCA Ordinances 2020-2021</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/393syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>MCA Syllabus 2020-2021</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/394syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. (CS) Hons (I year)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/400syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. (CS) Hons (II year)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/401syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Education
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Master of Education (M.Ed.)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/157syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre Ph.D. Coursework (Education)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/159syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre Ph.D. Coursework (Education)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/609syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Environmental Science
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Post Graduate Diploma in Disaster Management (PGDDM) </td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/413syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. in Environmental Science (effective from 2021-22)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/151syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Mathematics
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc./M.A. (Mathematics) </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/61syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc./ M.Phil., Ph.D. (Mathematics) Programme </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/63syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B. Sc./B.A. NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/398syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. (NEP) Mathematics</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/518syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Pre- Ph.D. Course-Work Programme Curriculum &amp; Syllabus
                                                        (Revised Syllabus)
                                                    </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/468syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Diploma in Vedic Mathematics</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/517syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc.</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/519syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D.</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/520syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        B.Sc. (Honours &amp; Honours with Research) Maths 2024-25
                                                    </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/b.sc_hons_hons_with_research_maths.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Microbiology
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc. Biotechnology 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/01/msc-biotechnology-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Bioinformatics 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/01/msc-bioinformatic-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Food Microbiology, Safety &amp; Quality Control</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/555syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Microbiology (CBCS)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/548syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Medical Microbiology (Three year program)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/556syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Bioinformatics</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/550syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Applied Microbiology</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/549syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Applied Microbiology</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/553syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Bioinformatics</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/554syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Microbiology (CBCS)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/552syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Food Microbiology, Safety &amp; Quality Control</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/551syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Microbiology</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/596syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Physics
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc. Physics</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/142syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. coursework</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/547syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/441syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Physics (Revised Syllabus)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/492syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Physics Honours &amp; Honours with Research 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_physics_hons_hons_with_research_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Physical Education
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.P.Ed. Syllabus 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/mped-syll.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.P.Ed. Syllabus 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/bped-syll.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.P.Ed. (Bachelor of Physical Education)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/67syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.P.Ed. (Master of Physical Education)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/68syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. (Physical Education)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/625syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Pharmacy
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody></tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Yoga Science{" "}
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>P.G. Diploma Yoga Science 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/01/pg-diploma-yoga-sc-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        B.A. B.Sc. Honours and Honours with Research- NEP Yoga Science
                                                        2024-25
                                                    </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/ba-bsc-hons-hons-with-research-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>PG Diploma M.A. M.Sc. Yoga Science 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/pg-dip-ma-msc-yoga-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A./B.Sc Yoga Science (2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/2022-23%20BA%20BSc%20Yoga%20Science.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Certificate Course in Advance Yogasana (2024-25)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/2024-25%20Certificate%20Course%20in%20Advance%20Yogasana.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Certificate Course in Concept of Guided Meditation (2024-25)
                                                    </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/2024-25%20Certificate%20Course%20in%20Concept%20and%20Application%20of%20Meditation.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Certificate Course in Pranayama (2024-25)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/2024-25%20Certificate%20Course%20in%20Pranayama.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Certificate Course in Yogasana (2024-25)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/2024-25%20Certificate%20Course%20in%20%20Yogasana.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Holistic Health &amp; Wellness (2024-25)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/2024-25%20value%20added%20holistic%20Health%20and%20Wellness.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A./M.Sc. Yoga Science (2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/2022-23%20M.A.%20M.Sc.%20Yoga%20Science%20Syllabus.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>PG Diploma in Yoga Science (2021-22)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/2021-22%20M_A_M_Sc_PG_Diploma_Yog_Science%20Syllabus.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Yoga and Happiness (2024-25)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/2024-25%20value%20Added%20Yoga%20and%20Happiness.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row-new">
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Statistics
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc. Statistics</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/507syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Statistics-n.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Statistics (2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/464syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Statistics</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/595syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Honours 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/b.sc_hons_statistic_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Zoology
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc . Environment Science 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/M.Sc.%20Environment%20revised%20syllabus%202024%20(NEP).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Zoology 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/M.Sc%20Zoology%20revised%20syllabus%202024.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Ph.D. (Zoology) Course Work</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/198syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Zoology-BSc-NEP-n.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Course Work Zoology</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/624syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>SpecializationTaxonomy in Zoology</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/specialization_taxonomy_in_zoology.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Value Added &amp; Skill Course B.Sc. Vermiculture &amp;
                                                        Vermicomposting
                                                    </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/value_added_&_skill_course.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Honours 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/02/bsc-zoo-honours-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Economics
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>BA (NEP) Economics 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/01/BA(NEP)_Economics_2024-25%20(1).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/436syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. (Honors) Economics</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/493syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Economics (Revised Syllabus)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/494syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Coursework in Economics</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/495syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Economics</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/497syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/626syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        B.A. (Honours and Honours with Research) Economics 2024-25
                                                    </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_b.a_hons_hons_with_research_eco_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of English
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>B.A. Honours English 1st year 2024</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/ba-hons-eng-1st-year-2024.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Phd Course work English 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/pre-phd-course-work-english-2024.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. English NEP 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/ma-eng-nep-2024.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. English NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/200syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Course Work English </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/602syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/BA-English-2022-23-NEP.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. English 2022-23</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/449syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Honours English </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/603syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Honours English 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_ba_hons_english_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Geography
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.A./.M.Sc. (Geography)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/34syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>P.G. Diploma in Disaster Management.</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/36syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A./.M.Sc. (Geography)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/538syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>P.G. Diploma in Remote Sensing and GIS</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/478syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A./ B.Sc. (Hons.) (Geography)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/476syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        PG Diploma in Remote Science and Geographic Information
                                                        Systems
                                                    </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/477syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A./M.Sc. (Geography) NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/594syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-PhD. Course Work Geography</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/597syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A./B.Sc. honours 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_b.a-b.sc_hons_geography_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Hindi
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Ph.D. </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/135syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. (Honours) Hindi</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/429syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/re-hindi-ug-nep.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Hindi (Revised Syllabus)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/466syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Hindi</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/505syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre Ph.D. Coursework Hindi</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/611syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Honours 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/b.a_hindi_hons_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of History
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>MA History</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/521syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>PG Diploma in Tourism and Hoteliering (Campus)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/523syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D Course Work</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/524syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Hons (History) </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/560syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/dept-history-ba.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. History (2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/451syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. (Ancient Indian History, Culture and Archaeology)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/544syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. NEP History 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_ma_nep_history_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. NEP History 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_ba_nep_histroy_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        M.A. NEP Ancient Indian History Culture Archaeology 2024-25
                                                    </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/ma_nep_ancient_india_history_culture_archaeology_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Honours Histroy Self Finance 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/ba_hon_history_self_finance_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Honours Histroy 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_ba_hons._history_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Home Science
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc. Home Science Clothing Textile 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/msc-homesc-clothing-textile-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Home Science Food and Nutrition</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/msc-homesc-food-nutrition-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Home Science Human Development</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/msc-homesc-human-development-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Home Science Clinical Nutrition 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/bsc-homesc-clinical-nutrition-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Home Science CBCS 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/bsc-homesc-cbcs-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Home Science CBCS 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/ma-homesc-cbcs-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Home Science (Food &amp; Nutrition)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/46syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. (Human Development) </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/47syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Hons. Home Science</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/558syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Home Science (2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/461syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Home Science</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/599syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Home Science</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/600syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Coursework (Home Science)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/608syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Journalism &amp; Mass Communication
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>BAJMC 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/05/bajmc-2025-26.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>BAJMC Honours 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/05/bajmc-hons.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>MAJMC 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/05/majmc.pdf  "
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Ph.D. (Journalism &amp; Mass communication)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/195syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Certificate Course in Mobile Journalism</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/410syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>P.G. Diploma in Public Relations and Advertising</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/409syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>P.G. Diploma in Film Production</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/408syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.AJMC (w.e.f. 2021-22)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/129syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>MAJMC (w.e.f. 2021-22)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/130syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Bachelor of Journalism and Mass Communication (B.J.M.C.)
                                                    </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/424syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Master of Journalism and Mass Communication (M.J.M.C.)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/423syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Library and Information Science
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        Bachelor of Library and Information Science (BLISc) (2022-23)
                                                    </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/587syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Master of Library and Information Science 2019-20</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/576syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. (Library and Information Science) (2023-24)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/601syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Bachelor of Library and Information Science 2009-10</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/570syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Master of Library and Information Science 2018-19</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/575syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. (Library and Information Science) 2020-21</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/527syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Bachelor of Library and Information Science 2005-06</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/569syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Bachelor of Library and Information Science 2016-17</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/571syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Master of Library and Information Science 2016-17</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/574syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Master of Library and Information Science 2007-08</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/572syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Master of Library and Information Science (MLISc) (2022-23)
                                                    </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/588syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Psychology
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.A. NEP Psychology 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/01/ma-psychology-nep-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Honours Psychology 2024-25 </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/01/ba-hons-psychology-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Value Add course Bioinformatics 2024-25 </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/01/value-add-course-bioinfo-2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Psychology </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/173syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/BA-Psychology-n.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Psychology (2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/455syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Engineering
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Ph.D Course Work Mechanical Engineering 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/phd-coursework-me.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Ph.D Course Work Computer Science & Engineering 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/phd-coursework-cse.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Ph.D Course Work Electronics & Communication Engineering 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/phd-coursework-ece.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Ph.D Course Work Agriculture Engineering 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/phd-coursework-ag.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-PhD course-work Agriculture Engineering</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/pre_phd_course_work_ag_2023-24.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Pre-PhD course-work Electronics &amp; Communication
                                                        Engineering
                                                    </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/pre-phd_course_work_ec_2023-24.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-PhD Computer Science and Engineering</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/pre-phd_course_work_cs_2023-24.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row-new">
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Foreign Languages
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Certificate of Proficiency in Russian</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/175syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Diploma in Russian Language</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/176syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Advanced Diploma in Russian Language &amp; Literature</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/177syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Certificate of Proficiency in French</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/178syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Diploma in French Language</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/179syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Advanced Diploma in French Language &amp; Literature</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/180syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Certificate of Proficiency in German</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/181syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Diploma in German Language</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/182syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Sanskrit
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.A. in Sanskrit</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/90syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>U.G. Minor Course in Sanskrit (NEP)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/616syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>P.G. Diploma in Karamkand</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/426syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>P.G. Diploma Jyotirvigyan (Revised Syllabus)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/427syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Sanskrit-n.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. in Sanskrit (NEP-2020)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/453syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Ph.D. Course Work (Sanskrit)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/617syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Sanskrit Honours (Value Added Course)2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/b.a_sanskrit_hons_VAC_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Sanskrit Honours 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_b.a_sanskrit_hons_1_yr_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Social Work
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Syllabus of Objective M.S.W. (Master of Social Work) </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/184syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.S.W. Programme</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/185syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Sociology
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td> M.A. Sociology</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/95syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>BA NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/561syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Master of Social Work (MSW)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/422syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Master of Social Work (MSW)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/484syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Sociology (2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/462syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre PhD Sociology</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/516syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Sociology (2023-24)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/622syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Sociology (2023-24)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/public/pdf/2024/01/M.A.%20Sociology%20(2023-24)_09-01-2024_1704778893.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Honours Sociology 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/b.a_hons_sociology_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Urdu
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Urdu Certificate Course (w. e. f. 2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/447syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Urdu</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/187syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Ph.D. </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/189syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/440syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Urdu Diploma Course (w. e. f. 2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/448syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Urdu (2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/463syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Urdu Minor Course (2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/465syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Honours Urdu 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/b.a_hons_urdu_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Food Science &amp; Technology
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc. Ag. Food Science &amp; Technology</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/508syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Ag. Food Science &amp; Technology</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/509syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Genetics &amp; Plant Breeding
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc. (Ag.) (as per ICAR Recommendations) </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/411syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. (Ag.) Genetics and Plant Breeding (New)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/191syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M. Sc. (Ag.) Genetics and Plant Breeding </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/480syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Ph.D. Genetics and Plant Breeding (w.e.f.2023-24)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/615syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Horticulture
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Pre-Ph.D. Horticulture</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/50syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. (Ag.) Horticulture</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/489syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. (Ag.) Horticulture (2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/456syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Plant Protection
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc. (Ag.) Plant Pathology 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/msc-ag-plant-pathology.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Ph.D. Plant Pathology 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/phd-plant-pathology.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Ag. (Entomology)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/545syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Ag. (Plant Pathology)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/546syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Ag (Entomology) based on CBCS pattern</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/192syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Ag. (Plant Pathology) based on CBCS pattern</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/193syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Seed Science &amp; Technology
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc.(Ag). Seed Science &amp; Technology</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/92syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M. Sc. (Ag) Seed Science and Technology</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/536syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td> M. Sc. (Ag) Seed Science and Technology</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/590syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Legal Studies
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>LL.M</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/566syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>LL.B. Three Year</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/567syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>L.L.M</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/488syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Ph.D</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/565syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. L.L.B.</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/487syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Coursework</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/621syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A., LL.B.</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/568syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Political Science
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.A. Political Science 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/ma-pol-sc-2024.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Political Science (CBCS System)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/76syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Coursework</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/78syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Public Administration </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/79syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/434syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Political Science (2022-23)</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/452syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Coursework</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/604syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Public Administration </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/618syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Political Science</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/619syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Under NEP</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus_camp/620syl.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Honours 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/b.a_political_sc_hons_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Political Science 2024-25 </td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/ma_political_science_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 style={{ fontSize: 15 }} className="my-heading text-center">
                                        Department of Fine Arts
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>BFA Honours (Drawing and Painting) 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/bfa-hons-drawing-painting.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>BFA Honours (Applied Arts) 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/bfa-hons-app-arts_compressed.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>BFA Honours (Textile Designing) 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/bfa-hons-textile-design_compressed.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>BFA Honours (Fashion Design) 2025-26</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/bfa-hono-fashion-design_compressed.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Education Arts 2024</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/11/edu-arts-2024.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Diploma Course Fine Arts 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/diploma_course_fine_arts_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.F.A Drawing &amp; Painting 2023-24</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_mfa_drawing_painting_2023-24.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.F.A Applied Arts 2023-24</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_mfa_applied_arts_2023-24.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.F.A Fashion Design 2023-24</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_mfa_fashion_design_2023-24.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.F.A Textile Design</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_master_of_fine_arts_mfa_textile_design_2023-24.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>BFA Honours 4 years 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_bfa_hons_4yrs_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>BFD Honours 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/syl_bfd_hons_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>MFA Diploma Course 2024-25</td>
                                                    <td align="center">
                                                        <div className="btn btn-primary btn-download">
                                                            <a
                                                                className=" float-none"
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/06/diploma_course_mfa_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default Main;